// src/components/atoms/UploadButton.js

import React from "react";
import { Button } from "@mui/material";
import { useTheme } from "styled-components";
import UploadIcon from "@mui/icons-material/Upload";

const UploadButton = ({ onFileSelect }) => {
  const theme = useTheme();
  const fileInputRef = React.useRef();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <>
      <input
        type="file"
        accept="image/*,video/*"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <Button
        variant="contained"
        startIcon={<UploadIcon />}
        onClick={handleButtonClick}
        sx={{
          backgroundColor: theme.colors.blue,
          color: theme.colors.white,
          borderRadius: "50px",
          padding: "10px 30px",
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: theme.colors.green,
            boxShadow: "none",
          },
        }}
      >
        Upload Media
      </Button>
    </>
  );
};

export default UploadButton;
